import { __rest, __assign } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';
import { Button } from '../../Button/Button.js';
import '../../Button/ButtonBase/index.js';
import '../../Button/ButtonBody/index.js';
import { Dialog } from '../../Dialog/Dialog.js';
import { DialogBody } from '../../Dialog/DialogBody.js';
import '@emotion/react';
import 'lodash.get';
import '@compono/ui-theme';
import 'deepmerge';
import '@emotion/is-prop-valid';
import '../../Box/index.js';
import '../../Dialog/DialogCloseButton.js';
import '../../Dialog/DialogContent.js';
import '../../Dialog/DialogCustomFooter.js';
import '../../Dialog/DialogCustomHeader.js';
import '../../Dialog/DialogLayout.js';
import '../../Dialog/DialogOverlay.js';
import { DialogPrimaryActions } from '../../Dialog/DialogPrimaryActions.js';
import '../../Dialog/DialogSecondaryActions.js';
import { DialogHeading } from '../../Dialog/DialogHeading.js';
import { TextInput } from '../../TextInput/TextInput.js';
import { useEditorContext } from '../EditorContext/EditorContext.js';
import { useLinkDialog } from './useLinkDialog.js';

var appendUrlScheme = function (url) {
    return url.substring(0, 3) === "www" ? "https://".concat(url) : url;
};
var EditorLinkDialog = function (props) {
    var isOpen = props.isOpen, closeDialog = props.closeDialog, dialogProps = __rest(props, ["isOpen", "closeDialog"]);
    var editorId = useEditorContext().editorId;
    var _a = useLinkDialog({
        closeDialog: closeDialog,
    }), label = _a.label, setLabel = _a.setLabel, url = _a.url, setUrl = _a.setUrl, writeLink = _a.writeLink;
    var handleUrlChange = function (e) {
        var value = e.currentTarget.value;
        return setUrl(appendUrlScheme(value));
    };
    return (jsxs(Dialog, __assign({ isOpen: isOpen, onDismiss: closeDialog, "aria-describedby": "dialog-body-".concat(editorId), "aria-labelledby": "dialog-heading-".concat(editorId) }, dialogProps, { children: [jsx(DialogHeading, __assign({ id: "dialog-heading-".concat(editorId) }, { children: "Edit link" })), jsxs(DialogBody, __assign({ id: "dialog-body-".concat(editorId) }, { children: [jsx(TextInput, { id: "editor-link-text", defaultValue: label, hint: "The text to display", label: "Link text", onChange: function (e) { return setLabel(e.currentTarget.value); } }), jsx(TextInput, { id: "editor-link-url", defaultValue: url, hint: "What URL should this link go to?", label: "Link URL", onChange: handleUrlChange })] })), jsxs(DialogPrimaryActions, { children: [jsx(Button, __assign({ look: "tertiary", onClick: closeDialog }, { children: "Cancel" })), jsx(Button, __assign({ onClick: function () { return writeLink({ url: url, label: label }); } }, { children: "Save" }))] })] })));
};

export { EditorLinkDialog, appendUrlScheme };
//# sourceMappingURL=EditorLinkDialog.js.map
